import { useMemo } from "react";
import "./style.scss";
import { numberWithCommas } from "../../../utils/methods";

function DBTable(props) {
    const { headers, rows, width, minWidth, onClickRow } = props;

    const gridTemplateColumns = useMemo(() => {
        let template = "";
        for (let i = 0; i < headers.length; i++) {
            template =
                template +
                headers[i].gridTemplateColumns +
                (i < headers.length - 1 ? " " : "");
        }
        return template;
    }, [headers]);

    const ids = useMemo(() => {
        return headers.map((item) => item.id);
    }, [headers]);

    return (
        <div className="dbTable-container">
            <div style={{ width, minWidth }}>
                <div className="dbTable-header" style={{ gridTemplateColumns }}>
                    {headers.map((item) => {
                        const style = item?.headerStyle
                            ? { ...item.headerStyle }
                            : {};
                        return (
                            <div key={item.id} style={style}>
                                {item.title}
                            </div>
                        );
                    })}
                </div>
                {rows.map((item, index) => {
                    return (
                        <div
                            key={index}
                            className="dbTable-row"
                            style={{
                                gridTemplateColumns,
                                cursor: !!onClickRow ? "pointer" : "default",
                            }}
                            onClick={() => onClickRow?.(item)}
                        >
                            {ids.map((element) => {
                                const headerItem = headers.find(
                                    (item) => item.id === element
                                );
                                const style = headerItem?.rowStyle || {};
                                const numericalComma =
                                    headerItem?.numberWithComma;
                                const value = numericalComma
                                    ? numberWithCommas(
                                          item[element]?.toString()
                                      )
                                    : item[element];
                                const label = headerItem?.title || "";
                                if (element !== "row") {
                                    return (
                                        <div
                                            key={element}
                                            style={style}
                                            data-label={label}
                                            data-col={element}
                                        >
                                            {value}
                                        </div>
                                    );
                                }
                                return (
                                    <div
                                        key={element}
                                        style={style}
                                        data-label={label}
                                        data-col={element}
                                    >
                                        <div>{value}</div>
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default DBTable;
